/**
 * In-memory map-resume signals (same-tab). Complements sessionStorage so recovery
 * still works if storage write fails or WebKit omits pairing with hidden timestamps.
 */

let lastHiddenWallClockMs = 0

/** True after pagehide, visibility hidden, or freeze since the last map-depart reset. */
let sawLifecycleBackgroundSinceMapMark = false

export function resetMapResumeLifecycle() {
  lastHiddenWallClockMs = 0
  sawLifecycleBackgroundSinceMapMark = false
}

/**
 * @param {number} [now]
 * @returns {number}
 */
export function recordHiddenWallClock(now = Date.now()) {
  lastHiddenWallClockMs = now
  sawLifecycleBackgroundSinceMapMark = true
  return now
}

export function getLastHiddenWallClockMs() {
  return lastHiddenWallClockMs
}

export function getSawLifecycleBackgroundSinceMapMark() {
  return sawLifecycleBackgroundSinceMapMark
}
